import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {Router} from "@angular/router";
import {FormIngresoService} from "../../../services/forms/form-ingreso.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {AlmacenService} from "../../../services/api/almacen.service";
import Swal from "sweetalert2";
import { AventuraService } from 'src/app/services/api/aventura.service';
import { Observable, map, startWith } from 'rxjs';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';

@Component({
  selector: 'app-dialog-inventario-aventura',
  templateUrl: './dialog-inventario-aventura.component.html',
  styleUrls: ['./dialog-inventario-aventura.component.css']
})
export class DialogInventarioAventuraComponent implements OnInit {

/*   myControl = new FormControl<string | any>('');
  myControlMarca = new FormControl<string | any>('');
  myControlModelo = new FormControl<string | any>(''); */

  filteredOptions!: Observable<any[]>;
  filteredOptionsMarca!: Observable<any[]>;
  filteredOptionsModelo!: Observable<any[]>;

  equipoForm!:FormGroup;
  estado:any;
  equipoId:any;

  loading:boolean=true;
  listaEquipos: any[]=[];
  listaNombres: any[]=[];
  listaMarcas: any[]=[];
  listaModelos: any[]=[];

  constructor(private router: Router, private fb: FormBuilder, private almacenService:AventuraService ,private formService: FormIngresoService ,
              public dialogRef: MatDialogRef<DialogInventarioAventuraComponent>, @Inject(MAT_DIALOG_DATA) public data:any,
             ) {

  }

  ngOnInit(): void {
    this.equipoForm = this.formService.getEquipoForm()

    this.getAllEquipos()
    console.log(this.data)

    this.equipoForm.get(['nombre'])?.setValue(this.data.nombre);
    this.equipoForm.get(['marca'])?.setValue(this.data.marca);
    this.equipoForm.get(['modelo'])?.setValue(this.data.modelo);
    this.equipoForm.get(['talla'])?.setValue(this.data.talla);
    this.equipoForm.get(['categoria'])?.setValue(this.data.categoria);
    this.equipoForm.get(['valoracion'])?.setValue(this.data.valoracion);
    this.equipoForm.get(['costo'])?.setValue(this.data.costo);
    this.equipoForm.get(['observaciones'])?.setValue(this.data.observaciones);
    this.equipoForm.get(['razonSocial'])?.setValue(this.data.razonSocial);
    this.equipoForm.get(['ruc'])?.setValue(this.data.ruc);
    this.equipoForm.get(['numFactura'])?.setValue(this.data.numFactura);
    this.estado=this.data.estado;
    this.equipoId=this.data.id;
    console.log(this.estado);

    this.filteredOptions = this.equipoForm.get(['nombre'])!.valueChanges.pipe(
      startWith(''),
      map(value => {
        const nombre = typeof value === 'string' ? value : value?.nombreInsumo;
        return nombre ? this._filter(nombre as string,"nombre") : this.listaNombres.slice();
      }),
    );

    this.filteredOptionsMarca = this.equipoForm.get(['marca'])!.valueChanges.pipe(
      startWith(''),
      map(value => {
        const nombre = typeof value === 'string' ? value : value?.nombreInsumo;
        return nombre ? this._filter(nombre as string,"marca") : this.listaMarcas.slice();
      }),
    );

    this.filteredOptionsModelo = this.equipoForm.get(['modelo'])!.valueChanges.pipe(
      startWith(''),
      map(value => {
        const nombre = typeof value === 'string' ? value : value?.nombreInsumo;
        return nombre ? this._filter(nombre as string,"modelo") : this.listaModelos.slice();
      }),
    );

  }

  getAllEquipos(){
    this.almacenService.getAllEquipos().subscribe(response=>{
      this.listaEquipos=response.getAllEquipos;

      const nombre = this.listaEquipos.filter((item: any) => item.nombre !== '' && item.nombre !== null).map((item: any) => (item.nombre))
      this.listaNombres= [...new Set(nombre)]

/*       const marca = this.listaEquipos.filter((item: any) => item.marca !== '' && item.marca !== null).map((item: any) => (item.marca))
      this.listaMarcas= [...new Set(marca)]

      const modelo = this.listaEquipos.filter((item: any) => item.modelo !== '' && item.modelo !== null).map((item: any) => (item.modelo))
      this.listaModelos= [...new Set(modelo)] */

    
      this.loading=false
    });
  }

  onSelectionChangedEquipo(event: MatAutocompleteSelectedEvent) {
    console.log(event.option.value)
    const marca = this.listaEquipos.filter((item: any) => item.nombre===event.option.value).map((item: any) => (item.marca))
    this.listaMarcas= [...new Set(marca)]

    console.log(this.listaMarcas)

  }

  onSelectionChangedMarca(event: MatAutocompleteSelectedEvent) {
    console.log(event.option.value)
    const modelo = this.listaEquipos.filter((item: any) => item.marca===event.option.value && item.nombre===this.equipoForm.value.nombre).map((item: any) => (item.modelo))
    this.listaModelos= [...new Set(modelo)]

    console.log(this.listaModelos)
  }
  
  createEquipo(){
    const item=this.listaEquipos.find((equipo:any)=>equipo.nombre===this.equipoForm.value.nombre && equipo.marca=== this.equipoForm.value.marca && equipo.modelo===this.equipoForm.value.modelo)
    console.log(item)
    const equipo={
      equipoId:item.id,
      nombreEquipo:this.equipoForm.value.nombre,
      marcaEquipo:this.equipoForm.value.marca,
      modeloEquipo:this.equipoForm.value.modelo,
      tallaEquipo:this.equipoForm.value.talla,
      categoria:item.categoria,
      valoracionEquipo:this.equipoForm.value.valoracion,
      costo:this.equipoForm.value.costo,
      observacionEquipo:this.equipoForm.value.observaciones,
      factura:{
        razonSocial:this.equipoForm.value.razonSocial,
        ruc:this.equipoForm.value.ruc,
        numFactura:this.equipoForm.value.numFactura
      }
    };
    console.log(this.equipoForm);
    console.log("equipo")
    console.log(equipo)
    this.almacenService.createEquipoInventario(equipo).subscribe(data=>{
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'Se agregó el equipo al almacén',
        showConfirmButton: false,
        timer: 4000
      });
      console.log("newEquipo");
      console.log(data)
      this.dialogRef.close(1);
    })
  }

  updateEquipo(){
    const item=this.listaEquipos.find((equipo:any)=>equipo.nombre===this.equipoForm.value.nombre && equipo.marca=== this.equipoForm.value.marca && equipo.modelo===this.equipoForm.value.modelo)
    
    const equipo={
      equipoId:item.id,
      nombreEquipo:this.equipoForm.value.nombre,
      marcaEquipo:this.equipoForm.value.marca,
      modeloEquipo:this.equipoForm.value.modelo,
      tallaEquipo:this.equipoForm.value.talla,
      categoria:item.categoria,
      valoracionEquipo:this.equipoForm.value.valoracion,
      costo:this.equipoForm.value.costo,
      observacionEquipo:this.equipoForm.value.observaciones,
      factura:{
        razonSocial:this.equipoForm.value.razonSocial,
        ruc:this.equipoForm.value.ruc,
        numFactura:this.equipoForm.value.numFactura
      }
    };

    this.almacenService.updateEquipoInventario(this.equipoId,equipo).subscribe(data=>{
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'Se modificó el equipo',
        showConfirmButton: false,
        timer: 4000
      });
      console.log("updatedEquipoDone");
      console.log(data)
      this.dialogRef.close(1);
    })
  }

  private _filter(nombre: string,option:string): any[] {
    const filterValue = nombre.toLowerCase();

    if(option==="nombre"){
      
      return this.listaNombres.filter((option) => option.toLowerCase().includes(filterValue));
    }
    else if(option==="marca"){

      return this.listaMarcas.filter((option) => option.toLowerCase().includes(filterValue));
    
    }
    else{
      return this.listaModelos.filter((option) => option.toLowerCase().includes(filterValue));
    }

  }

  getOptionText(option: any) {

    if (option && option.nombre) {
      return option.nombre;
    } else {
      return '';
    }
  }
}
